<tui-hosted-dropdown
  [tuiDropdownHideDelay]="500"
  tuiDropdownHover
  [content]="langMenu"
>
  <button tuiButton size="m" appearance="flat">
    <img class="w-[20px]" [src]="language$ | async | uppercase | tuiFlag" />
  </button>
</tui-hosted-dropdown>
<ng-template #langMenu>
  <tui-data-list role="menu">
    <button (click)="setLang(TuiCountryIsoCode.GB)" tuiOption>
      <img class="w-[20px]" [src]="TuiCountryIsoCode.GB | tuiFlag" />
    </button>
    <button (click)="setLang(TuiCountryIsoCode.IT)" tuiOption>
      <img
        class="w-[20px]"
        [src]="TuiCountryIsoCode.IT | uppercase | tuiFlag"
      />
    </button>
  </tui-data-list>
</ng-template>
